import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #UTILITY-NAV-ITEM
\*------------------------------------ */
/**
 * 1) List item that contains a link/button within the utility nav
 */
.cat-c-utility-nav__item {
  position: relative;
  margin: 0;
  padding: 0;
}
.cat-c-utility-nav__item:hover {
  background: var(--cat-theme-color-background-xstrong-hover);
}

/**
* Utility nav slotted custom link
*/
.cat-c-utility-nav__link ::slotted(a) {
  text-decoration: none;
  color: var(--cat-theme-color-content-knockout);
  cursor: pointer;
}
.cat-c-utility-nav__item.cat-is-current .cat-c-utility-nav__link ::slotted(a) {
  background: transparent;
  color: var(--cat-theme-color-content-knockout-brand);
}

/**
* Utility nav link
*/
.cat-c-utility-nav__link {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  display: flex;
  align-items: center;
  white-space: nowrap;
  position: relative;
  height: 100%;
  min-height: calc(var(--size-base-unit) * 7);
  border: none;
  background: none;
  appearance: none;
  padding: var(--cat-space-large) var(--cat-space-x-small);
  text-align: start;
  color: var(--cat-theme-color-content-knockout);
  cursor: pointer;
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  text-decoration: none;
  width: 100%;
}
.cat-c-utility-nav__link:focus-visible, .cat-c-utility-nav__link:focus {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-utility-nav__item.cat-is-active .cat-c-utility-nav__link {
  background: transparent;
}
.cat-c-utility-nav__item.cat-is-current .cat-c-utility-nav__link {
  background: transparent;
  color: var(--cat-theme-color-content-knockout-brand);
}

.cat-c-utility-nav__item.cat-is-current:not(.cat-is-mobile) .cat-c-utility-nav__bottom-border {
  border-start-start-radius: var(--cat-theme-border-radius);
  border-start-end-radius: var(--cat-theme-border-radius);
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  background: var(--cat-theme-color-border-brand);
  height: calc(var(--size-base-unit) * 0.5);
  margin-block-start: calc(-1 * var(--cat-space-3x-small));
  transition: background var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-utility-nav__mobile-view .cat-c-utility-nav__text {
    display: none;
  }
  .cat-c-utility-nav__mobile-view .cat-c-utility-nav__icon-before {
    margin-inline-end: 0;
  }
}
/**
* Utility nav icon
* 1) Pass properties down to icon component
*/
::slotted(cat-icon),
::slotted(.cat-icon) {
  --cat-icon-height: calc(var(--size-base-unit) * 2.5); /* 1 */
  --cat-icon-width: calc(var(--size-base-unit) * 2.5); /* 1 */
}

/**
* Utility nav icon directly after utility nav text
* 1) Create space between text and icon
*/
.cat-c-utility-nav__text + ::slotted(cat-icon),
.cat-c-utility-nav__text + ::slotted(.cat-icon) {
  margin-inline-start: var(--cat-space-x-small); /* 1 */
}

/**
* Utility nav text directly after utility nav icon
* 1) Create space between text and icon
*/
::slotted(cat-icon) + .cat-c-utility-nav__text,
::slotted(.cat-icon) + .cat-c-utility-nav__text {
  margin-inline-start: var(--cat-space-x-small); /* 1 */
}

/**
* Utility nav text directly after utility nav icon
* 1) Create space between text and icon
*/
.cat-c-utility-nav__icon-after {
  display: block;
  margin-inline-start: var(--cat-space-x-small);
  transition: transform var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-utility-nav__item.cat-is-active .cat-c-utility-nav__icon-after {
  transform: rotate(-180deg);
}

/**
* Utility nav text before utility nav icon
* 1) Create space between text and icon
*/
.cat-c-utility-nav__icon-before {
  margin-inline-end: var(--cat-space-x-small); /* 1 */
}

.cat-c-utility-nav__icon {
  pointer-events: none;
}

/**
 * Utility nav item panel
 * 1) Panel for the dropdown content
 * 1) Hide when not active
 */
.cat-c-utility-nav__item-panel {
  position: absolute;
  inset-block-start: 100%;
  inset-inline-end: 0;
  visibility: hidden; /* 1 */
  min-width: 12rem;
  width: 100%;
  height: 0; /* 1 */
  overflow: hidden; /* 1 */
  background: transparent;
  color: var(--cat-theme-color-content-default);
  border-radius: var(--cat-theme-border-radius);
  box-shadow: var(--cat-theme-box-shadow-md);
  border: var(--cat-theme-border-width) solid var(--cat-theme-color-border-default);
  opacity: 0; /* 1 */
  transition: all 0s var(--cat-anim-ease);
  z-index: -1;
  /**
  * utility nav item panel within active item
  * 1) Show the utility nav item dropdown
  */
}
.cat-c-utility-nav__item.cat-is-active .cat-c-utility-nav__item-panel {
  display: block;
  visibility: visible; /* 1 */
  height: auto; /* 1 */
  padding: var(--cat-space-3x-small);
  overflow: visible;
  background: var(--cat-theme-color-background-default);
  opacity: 1; /* 1 */
  z-index: var(--cat-z-index-400);
  transition: opacity var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
`;
       